import { util } from 'pevueglobal'
// state
const state = {
  forminputdata: {
    tbxName: '',
    rbgeslacht: '',
    tbxEdu: '',
    rbEerdereAanvraag: null,
    tbxTelefoon: '',
    tbxEmail: '',
    tbxAccrNr: '',
    tbxVraag: '',
    tbxextra: ''
  }
}

// getters
const getters = {}

// actions
const actions = {
  sendMail: async ({ rootState, commit }, inputdata) => {
    const output = await util.getDataApi('public/PEapi_SPE005_PR_HelpdeskMail', inputdata)
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          message: rootState.translation[45]
        },
        { root: true }
      )

      commit('clearfields')
    }
  }
}

// mutations
const mutations = {
  setforminputdata(state, forminputdata) {
    state.forminputdata = {
      ...state.forminputdata,
      ...forminputdata
    }
  },
  clearfields(state) {
    state.forminputdata = {
      tbxName: '',
      rbgeslacht: '',
      tbxEdu: '',
      rbEerdereAanvraag: null,
      tbxTelefoon: '',
      tbxEmail: '',
      tbxAccrNr: '',
      tbxVraag: '',
      tbxextra: ''
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
